import { Grid, Tooltip, TooltipProps, Typography } from "@mui/material"
import React from "react"
import { useStyles } from "./styles"

interface HtmlTooltipProps extends TooltipProps {
    disabled: boolean
    body: React.ReactNode
}

export const HtmlTooltip = ({ body, children, className, disabled, title, ...props }: HtmlTooltipProps) => {
    const { classes } = useStyles()

    const html = (
        <Grid>
            <Typography color="inherit" className={classes.text_label}>
                {title}
            </Typography>
            {body}
        </Grid>
    )

    return (
        <Tooltip
            arrow
            placement="bottom"
            title={!disabled ? html : ""}
            classes={{ tooltip: classes.tooltip }}
            className={className}
            {...props}
        >
            {children}
        </Tooltip>
    )
}
